import AwsS3 from "@uppy/aws-s3";

// Загрузка в S3 частями через наш api (гем uppy-s3_multipart, routes.rb: `mount
// UPPY_S3_* => "/s3/multipart"`). Все multipart-загрузчики берут плагин отсюда, а не
// из @uppy/aws-s3 напрямую: здесь собраны отличия нашего бэкенда от того, чего
// библиотека ждёт по умолчанию.
//
// 1. Режим companion: `companionEndpoint` — база маунта БЕЗ хвостового слэша.
//    Uppy 6 сам дописывает `/s3/multipart…` (lib/s3-client/CompanionS3.js).
//
// 2. shouldUseMultipart: true. Без флага файлы до 100 МБ уходят одним POST через
//    `GET /s3/params`. Такой ручки гем не монтирует — каждая фотография и каждый скан
//    паспорта падали бы на 404.
//
// 3. Ключ объекта — из ответа `/complete` (`uploadedKey` ниже). Uppy 6 обнуляет
//    `file.s3Multipart` ДО события upload-success, и прежнее `file.s3Multipart.key`
//    к постпроцессору приходит пустым. Ключ в `/complete` отдаёт гем с 1.3.1
//    (api#823, janko/uppy-s3_multipart#35). api выкатывается раньше фронта (R-002).
//
// Отмена, пришедшая пока POST create ещё в полёте. В Uppy 5 подкласс не отдавал create
// под сигнал и сам отменял созданный upload. В Uppy 6 S3-клиент — приватное поле
// плагина (`#s3Client`), подменить его вызов нечем: create обрывается вместе с fetch,
// а upload, который сервер уже создал, остаётся висеть на S3. Uppy 6 к тому же
// намеренно НЕ отменяет upload при ошибке (оставляет для повтора). Висящие загрузки
// чистит lifecycle-правило бакета AbortIncompleteMultipartUpload, а не клиент.
export class AwsS3Multipart extends AwsS3 {
  constructor(uppy, opts) {
    // id — прежний, из Uppy 2–5: в 6.x плагин по умолчанию зовётся "AwsS3".
    super(uppy, { id: "AwsS3Multipart", shouldUseMultipart: true, ...opts });
  }
}

/**
 * Ключ загруженного объекта — из ответа `/complete`.
 *
 * @param {object} file файл Uppy после upload-success (`file.response.body`)
 * @returns {string|null}
 */
export function uploadedKey(file) {
  const body = file && file.response && file.response.body;
  return (body && body.key) || null;
}

/**
 * Забыть загрузку файла, чтобы штатный повтор залил его ЗАНОВО.
 *
 * Загрузчик пропускает файлы с `progress.uploadComplete` (filterFilesToUpload в
 * @uppy/core/utils): байты уже в бакете, флаг стоит, и повтор прошёл бы мимо загрузки
 * сразу в постпроцессор — подтверждать прежний ключ. Ответ прошлой загрузки снимаем,
 * чтобы `uploadedKey` не вернул его до нового `/complete`; `s3Multipart` — чтобы
 * повтор шёл новым create, а не возобновлял прежний upload через listParts.
 *
 * @param {object} uppy инстанс @uppy/core
 * @param {string} fileID
 */
export function forgetMultipartUpload(uppy, fileID) {
  const file = uppy.getFile(fileID);
  if (!file) return;

  uppy.setFileState(fileID, {
    s3Multipart: null,
    response: null,
    uploadURL: null,
    progress: {
      ...file.progress,
      uploadComplete: false,
      uploadStarted: null,
      bytesUploaded: 0,
      percentage: 0,
    },
  });
}

export default AwsS3Multipart;
